import React from 'react'
import IssueNavigation from '../components/issue_navigation.js'

class Artwork extends React.Component {
  constructor() {
    super()
  }

  navigateToArtwork(event) {
    this.props.history.push(`/issue/${artwork_data.issue_date}/${artwork_data.media_type}/${event.target.value}`);
  }

  render () {
    const artwork_data = this.props.data.contributionsJson;
    const section_artworks = Array.from({length: artwork_data[`${artwork_data.media_type}_count`]}, (x,i) => i);
    const section_base_path = `/issue/${artwork_data.issue_date}/${artwork_data.media_type}`;
    const prev_link = artwork_data.position_in_section > 1 ?
      <a href={`${section_base_path}/${artwork_data.position_in_section - 1}`}>prev</a> :
      <span className="inactive">prev</span>;
    const next_link = artwork_data.position_in_section < artwork_data[`${artwork_data.media_type}_count`] ?
      <a href={`${section_base_path}/${artwork_data.position_in_section + 1}`}>next</a> :
      <span className="inactive">next</span>;
    
    /**
     * Source data contains only two types of media URIs: local (without
     * leading '/') and remote (just two HTTP URIs). For local, i.e. everything
     * that starts with 'media' (e.g. 'media/2008/August/still_image/06a.jpg'),
     * we prepend a leading '/' to make src attributes work properly.
     */
    const artwork_media_uri = artwork_data.media_uri.slice(0, 5) === 'media' ? `/${artwork_data.media_uri}` : artwork_data.media_uri;

    /**
     * Markup of player depends on content type: <img> for still images and textz
     * (which are images of text), <video> and <audio> for soundz and moving
     * images, respectively.
     */
    const artwork_players = {
      'still_image': <img src={`${artwork_media_uri}`}/>,
      'textz': <img src={`${artwork_media_uri}`}/>,
      'moving_image': <video src={`${artwork_media_uri}`} controls />,
      'soundz': <audio src={`${artwork_media_uri}`} controls />,
    };

    return (
      <div className="issue">
        <div className="sideBarLeft">
          <div className="cover">
            <a href={`/issue/${artwork_data.issue_date}`}>cover</a>
          </div>
          <div className="sections">
            <IssueNavigation issue_data={artwork_data} />
          </div>
          <div className="impressum">
            <ul>
              <li><a href={`/about/`}>about</a></li>
              <li><a href={`/editorial/`}>editorial</a></li>
              <li><a href={`/contact/`}>contact</a></li>
            </ul>
          </div>
          <div className="archive">
            <a href="/archive/">archive</a>
          </div>
        </div>
        <div className="artwork">
          {artwork_players[artwork_data.media_type]}
        </div>
        <div className="nav-and-metadata">
          <h3 className="nav">Navigate {artwork_data.media_type.replace('_', ' ')}</h3>
          <ul>
            <li>{prev_link}</li>
            <li>{next_link}</li>
            <li>
              <select onChange={this.navigateToArtwork} name="fastSelect" id="fastSelect" value={artwork_data.position_in_section}>
                {section_artworks.map((item, index) => {
                return <option key={index + 1} value={`/issue/${artwork_data.issue_date}/${artwork_data.media_type}/${index + 1}`}>{index + 1}</option>
                })}
              </select>
            </li>
          </ul>
          <h3 className="meta">Artwork Information</h3>
          <dl className="metadata">
            <dt>Theme</dt>
            <dd>{artwork_data.thema}</dd>

            <dt>Date</dt>
            <dd>{artwork_data.issue_month} {artwork_data.issue_year}</dd>

            <dt>Artwork</dt>
            <dd>{artwork_data.name}</dd>

            <dt>Artist</dt>
            <dd>{artwork_data.artist}</dd>

            <dt>Location</dt>
            <dd>{artwork_data.location}</dd>

            <dt className="hack"><a href={`mailto:${artwork_data.email}`}>email</a></dt>
            <dd><a href={artwork_data.www_url}>website</a></dd>
          </dl>
        </div>
      </div>
    );
  }
}

export default Artwork

export const query = graphql`
  query ArtworkQuery($id: String!) {
      # Select the artwork whose id matches this page's id.
      contributionsJson(id: {
          eq: $id
      }) {
          id
          name
          thema
          issue_month
          issue_year
          issue_date
          artist
          location
          email
          www_url
          media_type
          position_in_section
          media_uri
          media_th_uri
          still_image_count
          moving_image_count
          textz_count
          soundz_count
      }
  }
`


// WEBPACK FOOTER //
// ./src/templates/artwork.js